import React, { Component, ErrorInfo, ReactNode } from "react";
import { withTranslation } from "react-i18next";

interface ErrorBoundaryProps {
  children?: ReactNode;
  t: any;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return <h1>{this.props.t("Sorry..there was an error")}</h1>;
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
